// extracted by mini-css-extract-plugin
module.exports = {"container":"GridBlock_container__iplgD"};